import css from './modal.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function Modal({ number, callback }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    return (
        <div className={`connection-modal ${css['connection-modal']}`}>
            <div className="modal-content">
                <svg className="close" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" onClick={callback}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16ZM1.8 16C1.8 8.15756 8.15756 1.8 16 1.8C23.8424 1.8 30.2 8.15756 30.2 16C30.2 23.8424 23.8424 30.2 16 30.2C8.15756 30.2 1.8 23.8424 1.8 16Z"
                        fill="black"
                    />
                    <path
                        d="M10.3767 20.271C9.8849 20.7217 9.87466 21.1828 10.3459 21.6541C10.8172 22.1253 11.2783 22.1151 11.729 21.6233L16 17.4138L20.271 21.6233C20.7217 22.1151 21.1828 22.1253 21.6541 21.6541C22.1253 21.1828 22.1151 20.7217 21.6233 20.271L17.4138 16L21.6233 11.729C22.1151 11.2783 22.1253 10.8172 21.6541 10.3459C21.1828 9.87466 20.7217 9.88491 20.271 10.3767L16 14.5862L11.729 10.3767C11.2783 9.88491 10.8172 9.87466 10.3459 10.3459C9.87466 10.8172 9.8849 11.2783 10.3767 11.729L14.5862 16L10.3767 20.271Z"
                        fill="black"
                    />
                </svg>
                <p className="title">{t('step5_modal_title')}</p>
                <div className={`img img${number}`}>
                    <NextImage
                        webpSrc={require(`@publicLocal/solar-calculator/pc/6_${number}.webp`)}
                        src={require(`@publicLocal/solar-calculator/pc/6_${number}.jpg`)}
                        alt={t('step5_modal_title')}
                        aria-label={t('step5_modal_title')}
                    />
                </div>
            </div>
            <style global jsx>
                {`
                    .ecoflow-pc {
                        height: 100vh !important;
                        overflow: hidden !important;
                    }
                    #allContentContainer {
                        z-index: 1111;
                    }
                `}
            </style>
        </div>
    );
}
